export default __webpack_public_path__ + "static/media/m_cycles3.ff557048.png";